/** From Flutter `app_es.arb` — privacyPolicy* / termsOfService*. */
export const legalMessagesEs = {
  privacy: {
    pageTitle: "Política de privacidad",
    lastUpdated: "Última actualización: 1 de junio de 2026",
    introduction: {
      title: "Introducción",
      body: "WasOK es una aplicación local de ayuda para compras diseñada para ayudar a los usuarios a recordar productos que previamente han comprado, valorado o reseñado.\n\nEsta Política de privacidad explica qué información se procesa al usar la aplicación, cómo se almacenan los datos y cómo pueden operar ciertos servicios de terceros.",
    },
    dataStored: {
      title: "Datos almacenados por la aplicación",
      body: "WasOK almacena la siguiente información localmente en su dispositivo:\n\n• códigos de barras de productos escaneados\n• nombres y detalles de productos introducidos por el usuario\n• valoraciones y comentarios\n• listas de compras\n• categorías de productos\n• precios e información de tiendas\n• fotos de productos y tiendas\n\nSus datos de productos y fotos no se cargan en los servidores de WasOK.",
    },
    permissions: {
      title: "Permisos utilizados",
      camera: {
        title: "Cámara",
        body: "El acceso a la cámara se utiliza para:\n\n• escanear códigos de barras\n• tomar fotos de productos",
      },
      photos: {
        title: "Fotos y multimedia",
        body: "El acceso a fotos o la galería se utiliza solo cuando:\n\n• adjunta imágenes a productos\n• restaura copias de seguridad que contienen fotos",
      },
      files: {
        title: "Acceso a archivos y almacenamiento",
        body: "El acceso a archivos puede utilizarse para:\n\n• exportar archivos de copia de seguridad\n• importar copias de seguridad seleccionadas por el usuario\n• compartir listas de compras o copias de seguridad",
      },
    },
    backup: {
      title: "Copia de seguridad y exportación",
      body: "WasOK permite crear archivos de copia de seguridad con los datos de la aplicación y, opcionalmente, fotos.\n\nLos archivos de copia de seguridad se crean localmente en su dispositivo y pueden guardarse o compartirse mediante servicios elegidos por el usuario, como:\n\n• Google Drive\n• Dropbox\n• iCloud Drive\n• almacenamiento local del dispositivo\n\nWasOK no carga copias de seguridad en sus propios servidores.",
      onlineProductLookup: {
        title: "Búsqueda de producto en línea",
        body: "Si activa la búsqueda en línea por código de barras en Preferencias, WasOK puede enviar solo el número del código escaneado a bases de datos públicas (como Open Food Facts) para sugerir nombre y marca. WasOK no sube valoraciones, comentarios, fotos, listas de compra, categorías, información de tiendas ni copias de seguridad. Puede desactivarlo en cualquier momento en Preferencias.",
      },
    },
    advertising: {
      title: "Publicidad y servicios de terceros",
      intro:
        "WasOK utiliza servicios de terceros seleccionados para proporcionar ciertas funciones.",
      admob: {
        title: "Google AdMob",
        body: "Google AdMob se utiliza para mostrar anuncios dentro de la aplicación.\n\nGoogle y sus socios pueden procesar información como:\n\n• identificadores publicitarios\n• información del dispositivo\n• dirección IP\n• información de diagnóstico y uso\n\nEn ciertas regiones, se puede solicitar el consentimiento del usuario antes de mostrar anuncios personalizados.",
      },
      crashlytics: {
        title: "Firebase Crashlytics",
        body: "WasOK utiliza Firebase Crashlytics para ayudar a identificar fallos y mejorar la estabilidad de la aplicación.\n\nLos informes de fallos pueden incluir información técnica como:\n\n• modelo del dispositivo\n• versión del sistema operativo\n• versión de la aplicación\n• diagnósticos de fallos\n\nLos informes de fallos no incluyen intencionadamente sus valoraciones, notas, listas de compras o fotos de productos.",
      },
      externalProductDatabases: {
        title: "Bases de datos de productos externas",
        body: "La función de búsqueda por código de barras puede utilizar bases de datos de productos externas para obtener información del producto.\n\nPara más información, consulte las políticas de privacidad de los respectivos proveedores.",
      },
    },
    dataSecurity: {
      title: "Seguridad de los datos",
      body: "WasOK almacena los datos de la aplicación localmente en su dispositivo mediante mecanismos de almacenamiento proporcionados por el sistema operativo.\n\nAunque se adoptan medidas razonables para proteger los datos locales de la aplicación, ningún método de almacenamiento electrónico es completamente seguro.\n\nLos usuarios son responsables de mantener copias de seguridad de los datos importantes si lo desean.",
    },
    children: {
      title: "Privacidad de los niños",
      body: "WasOK no está dirigida a niños menores de 13 años.",
    },
    notifications: {
      title: "Notificaciones",
      body: "WasOK puede crear opcionalmente notificaciones locales en su dispositivo para recordarle que valore productos después de la compra.\n\nEstas notificaciones se generan y programan localmente en su dispositivo y no requieren una cuenta ni un servidor remoto.\n\nPuede desactivar las notificaciones en cualquier momento desde la configuración de su dispositivo o dentro de la aplicación, si está disponible.",
    },
    yourControl: {
      title: "Su control sobre los datos",
      body: "Usted puede:\n\n• editar o eliminar productos almacenados en cualquier momento\n• borrar los datos de la aplicación de su dispositivo\n• desinstalar la aplicación\n• exportar copias de seguridad de sus datos",
    },
    changes: {
      title: "Cambios en esta política",
      body: "Esta Política de privacidad puede actualizarse periódicamente.\n\nLos cambios entran en vigor cuando se publica la versión actualizada.",
    },
    contact: {
      title: "Contacto",
      body: "Si tiene preguntas sobre esta Política de privacidad, contacte:\n\nsupport@wasok.app",
    },
  },
  terms: {
    pageTitle: "Términos del servicio",
    lastUpdated: "Última actualización: 1 de junio de 2026",
    acceptance: {
      title: "Aceptación de los términos",
      body: "Al descargar, instalar o usar WasOK, usted acepta estos Términos del servicio.\n\nSi no está de acuerdo con estos Términos, no debe usar la aplicación.",
    },
    license: {
      title: "Licencia",
      body: "WasOK le otorga una licencia limitada, no exclusiva, intransferible y revocable para usar la aplicación de acuerdo con estos Términos.",
    },
    acceptableUse: {
      title: "Uso aceptable",
      body: "Usted acepta no:\n\n• hacer un uso indebido de la aplicación\n• interferir con el funcionamiento de la aplicación\n• intentar realizar ingeniería inversa o modificar la aplicación\n• usar la aplicación infringiendo leyes o normativas aplicables",
    },
    localData: {
      title: "Datos locales y copias de seguridad",
      body: "WasOK almacena los datos del usuario localmente en el dispositivo.\n\nLos usuarios son responsables de mantener copias de seguridad de los datos importantes si lo desean.\n\nAunque puede ofrecerse funcionalidad de copia de seguridad y restauración, WasOK no garantiza contra la pérdida, corrupción o fallo de los datos almacenados.",
    },
    advertisements: {
      title: "Anuncios",
      body: "La aplicación puede mostrar anuncios proporcionados por socios publicitarios de terceros, incluido Google AdMob.",
    },
    noWarranty: {
      title: "Sin garantía",
      body: "WasOK se proporciona \"tal cual\" y \"según disponibilidad\" sin garantías de ningún tipo, expresas o implícitas.\n\nNo garantizamos que:\n\n• la aplicación esté siempre disponible\n• la aplicación esté libre de errores\n• nunca se produzca pérdida de datos\n• todas las funciones funcionen sin interrupciones en todos los dispositivos",
    },
    limitationLiability: {
      title: "Limitación de responsabilidad",
      body: "En la máxima medida permitida por la ley, WasOK y sus desarrolladores no serán responsables de:\n\n• pérdida de datos\n• pérdida de beneficios\n• problemas del dispositivo\n• daños indirectos o consecuentes\n• interrupciones derivadas del uso o la imposibilidad de usar la aplicación",
    },
    thirdParty: {
      title: "Servicios de terceros",
      body: "Ciertas funciones o contenidos pueden depender de servicios de terceros, incluidos proveedores publicitarios y servicios externos de almacenamiento o uso compartido seleccionados por el usuario.\n\nWasOK no es responsable de los servicios de terceros ni de sus políticas.",
    },
    productInformation: {
      title: "Información del producto",
      body: "Ciertos detalles de productos pueden obtenerse de servicios de terceros de búsqueda por código de barras.\n\nWasOK no garantiza la exactitud, integridad, disponibilidad o idoneidad de la información proporcionada por fuentes de datos externas.\n\nLos usuarios deben verificar de forma independiente la información del producto cuando sea necesario.",
    },
    changesApp: {
      title: "Cambios en la aplicación",
      body: "WasOK puede modificarse, actualizarse, suspenderse o discontinuarse en cualquier momento sin previo aviso.",
    },
    changesTerms: {
      title: "Cambios en estos Términos",
      body: "Estos Términos pueden actualizarse periódicamente.\n\nEl uso continuado de la aplicación después de que las actualizaciones entren en vigor constituye la aceptación de los Términos revisados.",
    },
    contact: {
      title: "Contacto",
      body: "Para preguntas sobre estos Términos, contacte:\n\nsupport@wasok.app",
    },
  },
};
